import { UniqueIdentifier, useDraggable } from '@dnd-kit/core';
import { useQuizContext } from '../../../../context/QuizContext';
import { SentenceDnDItem } from './SentenceDnDItem';

interface DraggableProps {
  value: string;
  id: UniqueIdentifier;
  isCorrect?: boolean;
}

/**
 * SentenceDraggableItem.
 */
export const SentenceDraggableItem = ({
  value,
  id,
  isCorrect,
}: DraggableProps) => {
  const { isAnswered } = useQuizContext();

  const { isDragging, setNodeRef, listeners } = useDraggable({
    id,
    disabled: isAnswered,
  });

  return (
    <SentenceDnDItem
      value={value}
      isCorrect={isCorrect}
      isDragging={isDragging}
      setNodeRef={setNodeRef}
      listeners={listeners}
    />
  );
};
